import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable, of, Subject} from 'rxjs';
import {Profile} from '../model/profile';
import {Favorite} from '../model/favorite';
import {Product} from "../model/product";

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private profile: Profile;
  private allowedProducts: Product[];
  private subject = new Subject<Profile>();
  private allowedProductsSubject = new Subject<Product[]>();
  public RGPDPopupOpened = false;

  constructor(private http: HttpClient) {
    this.http.get<Profile>(`${environment.backend}/profile`).subscribe(data => {
      this.profile = data;
      this.subject.next(this.profile);
      this.allowedProducts = this.profile.contracts.map(contract => contract.product)
      this.allowedProductsSubject.next(this.allowedProducts);
    });
  }

  getProfile(): Observable<Profile> {
    if (this.profile) {
      return of(this.profile);
    } else {
      return this.subject.asObservable();
    }
  }

  readRgpd(): void {
    this.http.post<void>(`${environment.backend}/profile/rgpd`, null).subscribe(() => {
      this.profile.rgpd.accepted = true;
    });
  }

  addFavorite(fav): void {
    this.http.post<Favorite>(`${environment.backend}/profile/favorite`, fav).subscribe(data => {
      this.profile.favorites.push(data);
      this.subject.next(this.profile);
    });
  }

  removeFavorite(fav): void {
    this.http.delete(`${environment.backend}/profile/favorite/${fav.id}`).subscribe(() => {
      this.profile.favorites = this.profile.favorites.filter(f => f.id !== fav.id);
      this.subject.next(this.profile);
    });
  }

  resetPasswordRequest(): Observable<void> {
    return this.http.post<void>(`${environment.backend}/profile/password`, {});
  }

  deleteMeRequest(): Observable<void> {
    return this.http.delete<void>(`${environment.backend}/profile`, {});
  }

  getAllowedProducts(): Observable<Product[]> {
    if (this.allowedProducts) {
      return of(this.allowedProducts);
    } else {
      return this.allowedProductsSubject.asObservable();
    }
  }
}
